import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import './../bootstrap/bootstrap.scss';

Vue.use(BootstrapVue);

export default BootstrapVue;
